import $ from 'jquery'
// import 'materialize-css'
import ScrollReveal from 'scrollreveal'

// Base
import './common';
import './forms';
import M from "materialize-css";

function showValidation(errors) {
  $('.helper').remove();
  $('.invalid').removeClass('invalid');
  $.each(errors, function (i, err) {
    if (err.field) {
      i = err.field;
      err = err.message;
    }
    var $row = $('#' + i).parent();
    if ($row.length) {
      if (!$row.find('.helper').length) {
        $row.append('<span class="helper invalid"></span>');
      }
      const $helper = $row.find('.helper');
      $row.find('input').addClass('invalid');
      if(typeof err === 'string') {
        $helper.html(err);
      } else if(err.length === 1) {
        $helper.html(err[0]);
      } else {
        var html = '';
        $.each(err, function (i, e) {
          html += '- ' + e + '<br>';
        });
        $helper.html(html);
      }

    }
  })
}

$.fn.serializeObject = function () {
  let o = {};
  let a = this.serializeArray();
  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};
window._ = require('lodash');
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
} catch (e) {
}

try {
  window.aos = window.animateOnScroll = require('aos');
  window.slick = window.slickCarousel = require('slick-carousel');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}




// WEBPACK FOOTER //
// ./resources/assets/js/app.js